export const REGEX_PHONE_NUMBER = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}/;
export const REGEX_MOBILE_NUMBER = /^[0-9]{3}-[0-9]{3,4}-[0-9]{4}/;
export const REGEX_EMAIL = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
